<template>
    <div class="home">
        <cp-header
            v-if="menu && menu.length"
            :menu="menu"
            :current="current"
            @tapMenuItem="onMenuItemTap"></cp-header>
        <div class="fullpage-container">
            <div class="fullpage-wp" v-fullpage="option" ref="fullpage">
                <div class="page">
                    <cp-brand
                        v-if="banner"
                        :data="banner"
                        :is-in-view="current === 0"/>
                </div>
                <div class="page">
                    <cp-doctor
                        v-if="doctor"
                        :data="doctor"
                        :is-in-view="current === 1"/>
                </div>
                <div class="page">
                    <cp-case
                        v-if="issue"
                        :data="issue"
                        :is-in-view="current === 2"/>
                </div>
                <div class="page">
                    <cp-follow
                        v-if="follow"
                        :data="follow"
                        :is-in-view="current === 3"/>
                </div>
            </div>
        </div>
        <div class="home-navi">
            <div
                v-for="(item, i) in menu"
                :class="[
                    'home-navi-item',
                    i === current ? 'home-navi-current' : 'home-navi-common',
                    menu[current].mode === 'dark' ? 'dark' : ''
                ]"
                @click="onMenuItemTap({data:item, index: i})"></div>
        </div>
    </div>
</template>

<script>
import 'fullpage-vue/src/fullpage.css';

import CpHeader from '@/components/home/Header';
import CpBrand from '@/components/home/Brand';
import CpDoctor from '@/components/home/Doctor';
import CpCase from '@/components/home/Case';
import CpFollow from '@/components/home/Follow';

import {request} from '@/utils/request';
import {apiHost} from '@/utils/conf';

export default {
    name: 'wz-home',
    components: {
        CpHeader,
        CpBrand,
        CpDoctor,
        CpCase,
        CpFollow
    },
    data() {
        const vm = this;
        return {
            option: {
                start: 0,
                dir: 'v',
                duration: 500,
                beforeChange(el, current, next) {
                    vm.current = next;
                },
                afterChange(el, current) {
                }
            },
            current: 0,
            menu: [],
            banner: null,
            issue: null,
            doctor: null,
            follow: null,
            fullpage: null
        }
    },
    mounted() {
        this.fullpage = this.$refs.fullpage.$fullpage;
        this.init();
    },
    methods: {
        init() {
            request({
                url: apiHost + '/med/page/pcindex?vn=med'
            }).then(resp => {
                const {
                    menu,
                    banner,
                    doctor,
                    follow
                } = resp.data;
                Object.assign(this, {
                    menu,
                    banner,
                    doctor,
                    follow,
                    issue: resp.data.case
                });
            });
        },
        onMenuItemTap({data, index}) {
            this.current = index;
            this.fullpage.moveTo(index, true);
        }
    }
}
</script>

<style scoped>
.home {
    position: relative;
    height: 100vh;
    width: 100%;
}
.home-navi {
    position: absolute;
    top: 50%;
    right: .4rem;
    z-index: 5;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
}
.home-navi-item {
    cursor: pointer;
    margin-bottom: .2rem;
    transition: all .3s ease;
}
.home-navi-current {
    width: .1rem;
    height: .1rem;
    border-radius: 50%;
    border: .03rem solid #00C8C8;
    opacity: 1;
}
.home-navi-current.dark {
    border: .03rem solid #FFF;
}
.home-navi-common {
    width: .04rem;
    height: .04rem;
    border-radius: 50%;
    border: 0 solid transparent;
    background-color: #00C8C8;
}
.home-navi-common.dark {
    background-color: #FFF;
}
</style>



// WEBPACK FOOTER //
// src/pages/wz/Brand.vue